import React from 'react';
import { BsTwitter } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://twitter.com/devwanjohi">
        <BsTwitter />
      </a>
    </div>

    <div>
      <a href="https://github.com/wanjohiwamuchiri">
        <FaGithub />
      </a>
    </div>

  </div>
);

export default SocialMedia;
